import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '../../public/services/auth.service';
import { UserLoggedService } from '../services/userLogged.service';
import { SCREEN_LOGGED, TOKEN } from '../constants/storage';
import { ScreenLoggedService } from '../services/screenLogged.service';
import { UserService } from 'src/app/private/services/user.service';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { LocalStorageService } from '../services/storage.service';

@Injectable({
    providedIn: 'root',
})
export class PrivateViewGuard implements CanActivate {
    helper: JwtHelperService;

    constructor(
        private router: Router,
        private authService: AuthService,
        private userService: UserService,
        private userLoggedService: UserLoggedService,
        private screenLoggedService: ScreenLoggedService,
        private localStorageService: LocalStorageService
    ) {
        this.helper = new JwtHelperService();
    }

    async canActivate(): Promise<boolean> {
        const token = this.localStorageService.getItem(TOKEN);
        const userLogged = this.userLoggedService.userLogged;

        if (
            token == 'null' ||
            token == 'undefined' ||
            !token ||
            this.helper.isTokenExpired(token)
        ) {
            this.authService.logout();
            this.router.navigate(['/auth/login']);

            return false;
        }

        const dataToken = this.helper.decodeToken(token);

        if (userLogged === null) {
            const user = await this.userService.getById(dataToken.user.id) as UserDto;
            this.userLoggedService.setUserLogged(user);
        }

        const screenSaved =
            this.localStorageService.getItem(SCREEN_LOGGED) !== null
                ? this.localStorageService.getItem(SCREEN_LOGGED)
                : null;

        if (screenSaved != null) {
            this.screenLoggedService.setScreen(screenSaved);
        }

        return true;
    }
}
